// Fills {{price:routes.jfk-manhattan.sedan}} placeholders in pageMeta.json from prices.json, so
// titles and descriptions always show the same prices as the pages. CommonJS so the build scripts
// can require it too. Returns null when a price is missing (strict: throws instead).
const PRICES = require('./prices.json');

function fillPrices(text, { strict = false } = {}) {
  if (!text) return text;
  let missing = null;
  const out = text.replace(/\{\{price:([\w.-]+)\}\}/g, (match, path) => {
    const value = path.split('.').reduce((o, k) => (o == null ? undefined : o[k]), PRICES);
    if (typeof value !== 'number' || !(value > 0)) {
      missing = path;
      return match;
    }
    return `$${Math.round(value)}`; // whole dollars, like the pages (landing/prices.js)
  });
  if (missing && strict) throw new Error(`No price in prices.json for ${missing}`);
  return missing ? null : out;
}

module.exports = { fillPrices };
